import { render, staticRenderFns } from "./ConsortiumPanel.vue?vue&type=template&id=16816906&scoped=true&"
import script from "./ConsortiumPanel.vue?vue&type=script&lang=js&"
export * from "./ConsortiumPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16816906",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/party/ConsortiumPanel.vue
// module id = 1482
// module chunks = 0